export const hasWindow = () => {
  return typeof window !== 'undefined';
};
